import { useState } from 'react';
import { GraduationCap, Users, BookOpen } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router';
import { registerPreper } from '../../services/registerService';
import { useAuth } from '../../contexts/authContext';

const roles = [
  {
    id: 'student',
    title: 'Student',
    description: 'Access courses, submit assignments, and track your progress',
    icon: GraduationCap,
    color: 'text-primary'
  },
  {
    id: 'lecturer',
    title: 'Lecturer',
    description: 'Create courses, manage students, and share your knowledge',
    icon: BookOpen,
    color: 'text-secondary'
  },
  {
    id: 'regular',
    title: 'Regular User',
    description: 'Browse content and participate in discussions',
    icon: Users,
    color: 'text-accent'
  }
];

function RoleSelectionPage() {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let {user, setUser, setProfile} = useAuth();

  const handleRoleSelection = async () => {
    if (!selectedRole) {
      toast.error('Please select a role to continue');
      return;
    }

    setIsLoading(true);
    try {
      // await updateUserRole(selectedRole);
      toast.success('Role updated successfully');
      
      // Redirect based on role
      switch (selectedRole) {
        case 'student':
          navigate('/complete-profile/student');
          break;
        case 'lecturer':
          navigate('/complete-profile/lecturer');
          break;
        default:
          let response = await registerPreper();
          
          // Set user and profile in AuthContext
          setUser(response.user);
          setProfile(response);
    
          // raise alert
          toast.success('Successfully Completed your profile')
          navigate('/profile');
      }
    } catch (error) {
      console.error('Failed to update role:', error);
      toast.error('Failed to update role. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-base-200 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">Welcome to ExamPrep!</h1>
          <p className="text-base-content/70 mt-2">
            Please select your role to continue
          </p>
        </div>

        <div className="bg-base-100 shadow-xl rounded-box p-8">
          <div className="grid gap-6 md:grid-cols-3">
            {roles.map((role) => {
              const Icon = role.icon;
              return (
                <div
                  key={role.id}
                  className={`card bg-base-100 border-2 cursor-pointer transition-all duration-200 hover:shadow-lg ${
                    selectedRole === role.id
                      ? 'border-primary shadow-lg'
                      : 'border-base-300 hover:border-primary/50'
                  }`}
                  onClick={() => setSelectedRole(role.id)}
                >
                  <div className="card-body items-center text-center">
                    <div className={`rounded-full p-3 ${role.color} bg-base-200`}>
                      <Icon className="h-6 w-6" />
                    </div>
                    <h2 className="card-title mt-4">{role.title}</h2>
                    <p className="text-sm text-base-content/70">
                      {role.description}
                    </p>
                  </div>
                </div>
              )
            })}
          </div>

          <div className="mt-8 flex justify-end">
            <button
              className={`btn btn-primary ${isLoading ? 'loading' : ''}`}
              onClick={handleRoleSelection}
              disabled={!selectedRole || isLoading}
            >
              {isLoading ? 'Updating...' : 'Continue'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoleSelectionPage;
